"use strict";
/**
 * 全局认证配置中心
 * 所有微服务都使用这个统一的配置，避免重复配置
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBackendAuthConfig = exports.createServiceAuthConfig = exports.GLOBAL_AUTH_CONFIG = void 0;
// 全局认证配置
exports.GLOBAL_AUTH_CONFIG = {
    // JWT 配置
    jwt: {
        secret: (typeof process !== 'undefined' && process.env?.JWT_SECRET) || 'your-super-secret-jwt-key-here',
        expiresIn: '2h',
        refreshExpiresIn: '7d',
        issuer: 'msadmin-auth',
        audience: 'microservices',
    },
    // msLogin 配置
    msLogin: {
        // 优先使用 REACT_APP_MSLOGIN_URL（React前端环境变量）
        // 其次使用 MSLOGIN_URL（Node.js后端环境变量）
        // 最后使用生产环境默认值
        url: (typeof process !== 'undefined' && process.env?.REACT_APP_MSLOGIN_URL) ||
            (typeof process !== 'undefined' && process.env?.MSLOGIN_URL) ||
            'https://login.homaxs.com',
        apiUrl: (typeof process !== 'undefined' && process.env?.MSLOGIN_API_URL) || 'https://login.homaxs.com',
        loginPath: '/login',
        logoutPath: '/logout',
        verifyPath: '/api/auth/verify',
    },
    // 统一的 token 配置
    tokens: {
        mainTokenKey: 'mslogin_token',
        refreshTokenKey: 'mslogin_refresh_token',
        userKey: 'mslogin_user',
    },
    // 微服务配置
    services: {
        msadmin: {
            name: 'msadmin',
            port: 50091,
            frontendPort: 30091,
            homeUrl: '/services',
        },
        msspace: {
            name: 'msspace',
            port: 50035,
            frontendPort: 30035,
            homeUrl: '/space-tree',
        },
        msmq: {
            name: 'msmq',
            port: 50032,
            frontendPort: 30032,
            homeUrl: '/dashboard',
        },
        mslog: {
            name: 'mslog',
            port: 50092,
            frontendPort: 30092,
            homeUrl: '/logs',
        },
        msstun: {
            name: 'msstun',
            port: 50081,
            frontendPort: 30081,
            homeUrl: '/',
        },
        msdevice: {
            name: 'msdevice',
            port: 50041,
            frontendPort: 30041,
            homeUrl: '/',
        },
        mshotel: {
            name: 'mshotel',
            port: 50039,
            frontendPort: 30039,
            homeUrl: '/',
        },
        msversion: {
            name: 'msversion',
            port: 50093,
            frontendPort: 30093,
            homeUrl: '/',
        },
        msincome: {
            name: 'msincome',
            port: 50045,
            frontendPort: 30045,
            homeUrl: '/income',
        },
        msAi: {
            name: 'msAi',
            port: 50083,
            frontendPort: 30083,
            homeUrl: '/resource',
        },
    },
};
/**
 * 为特定微服务生成认证配置
 */
function createServiceAuthConfig(serviceName) {
    const service = exports.GLOBAL_AUTH_CONFIG.services[serviceName];
    // const hostname = (typeof globalThis !== 'undefined' && (globalThis as any).window) ? (globalThis as any).window.location.hostname : 'localhost';
    return {
        serviceName: service.name,
        apiBaseUrl: `http://localhost:${service.port}`,
        msLoginUrl: exports.GLOBAL_AUTH_CONFIG.msLogin.url,
        tokenKey: exports.GLOBAL_AUTH_CONFIG.tokens.mainTokenKey,
        refreshTokenKey: exports.GLOBAL_AUTH_CONFIG.tokens.refreshTokenKey,
        loginUrl: exports.GLOBAL_AUTH_CONFIG.msLogin.loginPath,
        logoutUrl: exports.GLOBAL_AUTH_CONFIG.msLogin.logoutPath,
        homeUrl: service.homeUrl,
        authEndpoint: exports.GLOBAL_AUTH_CONFIG.msLogin.verifyPath,
    };
}
exports.createServiceAuthConfig = createServiceAuthConfig;
/**
 * 后端认证配置
 */
function createBackendAuthConfig(serviceName, port) {
    const service = exports.GLOBAL_AUTH_CONFIG.services[serviceName];
    return {
        serviceName: service.name,
        apiBaseUrl: `http://localhost:${port}`,
        msLoginUrl: exports.GLOBAL_AUTH_CONFIG.msLogin.apiUrl,
        tokenKey: exports.GLOBAL_AUTH_CONFIG.tokens.mainTokenKey,
        refreshTokenKey: exports.GLOBAL_AUTH_CONFIG.tokens.refreshTokenKey,
        loginUrl: exports.GLOBAL_AUTH_CONFIG.msLogin.loginPath,
        logoutUrl: exports.GLOBAL_AUTH_CONFIG.msLogin.logoutPath,
        homeUrl: service.homeUrl,
        authEndpoint: exports.GLOBAL_AUTH_CONFIG.msLogin.verifyPath,
    };
}
exports.createBackendAuthConfig = createBackendAuthConfig;
exports.default = exports.GLOBAL_AUTH_CONFIG;
